import EntityService from "./entity";
import { request } from '../http/http'

class ExhibitService extends EntityService {
  constructor(name) {
    super(name)
  }
}

export default new ExhibitService("exhibit")

export function getExhibitsByPage(params) {
  return request({
    url: "/web/exhibitPage",
    method: "get",
    params
  })
}



// WEBPACK FOOTER //
// ./src/services/exhibit.js